import { Draggable } from '@fullcalendar/interaction';

export class ActivityDraggableController {
  private instance?: Draggable;

  /**
   * Syncs the Draggable instance for the given view mode: destroys it in
   * 'resources' mode, (re)creates it in 'standard' mode when the container
   * is available.
   */
  syncForMode(
    mode: 'standard' | 'resources',
    container: HTMLElement | undefined
  ): void {
    if (mode === 'resources') {
      this.instance?.destroy();
      this.instance = undefined;
      return;
    }

    if (container) {
      this.init(container);
    }
  }

  private init(container: HTMLElement): void {
    this.instance?.destroy();
    this.instance = new Draggable(container, {
      itemSelector: '.activity[role="button"]',
      eventData: eventEl => ({
        id: eventEl.id,
        title: eventEl.getAttribute('data-title') || 'Nuova attività',
        create: false,
      }),
    });
  }
}

/**
 * Attaches the activity id/dropAbilita flag to a native HTML5 dragstart
 * event, used by the resources view's own drop handling
 * (`onResourceExternalDrop`).
 */
export function setActivityDragData(
  event: DragEvent,
  act: { id?: string; numeroAppuntamentiDaCalendarizzare?: number }
): void {
  if (!act.id) return;
  event.dataTransfer?.setData('activityId', act.id);
  event.dataTransfer?.setData(
    'dropAbilita',
    act?.numeroAppuntamentiDaCalendarizzare ? 'true' : 'false'
  );
}
